import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { selectPivotFieldsState } from "../../../../store/selectors/fieldsStateSelectors";
import { selectMeasures } from "../../../../store/selectors/metaDataSelectors";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks";
import { updateCalculateByFieldForCustomMeasures } from "../../utils/MeasureUtils";

const useTrackMeasuresListUpdate = () => {
  const dispatch = useAppDispatch();
  const measures = useSelector(selectMeasures);
  const fieldsState = useSelector(selectPivotFieldsState);
  const fieldsStateRef = useRef(fieldsState);
  useEffect(() => {
    fieldsStateRef.current = fieldsState;
  }, [fieldsState]);

  useEffect(
    () =>
      updateCalculateByFieldForCustomMeasures(
        {
          updateMeasure: (field, changes) => dispatch(fieldsStateActions.updateMeasure({ field, changes })),
          updateMeasureConfig: (field, changes) => dispatch(fieldsStateActions.updateMeasureConfig({ field, changes })),
          removeMeasure: (field) => dispatch(fieldsStateActions.removeMeasure(field)),
          values: fieldsStateRef.current.values,
        },
        measures
      ),
    [measures, dispatch]
  );
};

export default useTrackMeasuresListUpdate;
